/**
 * Stringify API nutrition values without rounding (e.g. 4152.78 → "4152.78").
 */
export function formatNutritionApiRaw(value: number | undefined | null): string {
  if (value == null || !Number.isFinite(value)) return '0';
  return String(value);
}

/**
 * Nutrition display: round to 2 decimal places, then trim trailing zeros (e.g. 300.9876 → "300.99", 300.98 → "300.98", 300.9 → "300.9", 300 → "300").
 */
export function roundNutritionDisplay(value: number): string {
  if (!Number.isFinite(value)) return '0';
  const rounded = Math.round(value * 100) / 100;
  const fixed = rounded.toFixed(2);
  if (fixed.endsWith('.00')) return String(Math.trunc(rounded));
  if (fixed.endsWith('0')) return fixed.slice(0, -1);
  return fixed;
}
